import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import { bindActionCreators, Dispatch } from "redux"
import { connect } from "react-redux"
import { RouteComponentProps } from "react-router"
import BasePage, { Props as BasePageProps } from "../base-page"
import * as actionCreators from "../../action-creators"
import { DELETE } from "../../constant/misc"
import * as UserDomain from "../../domain/sfp/user-domain"
import { User, Title } from "../../model"
import { ReducerState, MappedActionsProps } from "../../reducer"
import * as UsersService from "../../service/sfp/users-service-2"
import * as RegionsService from "../../service/sfp/regions-service"
import { findTitles } from "../../service/sfp/titles-service"
import UserDetailModal from "../user-detail-modal"
import { ToolbarItem } from "../toolbar"
import "./../style/_users.scss"
import Spinner from "react-spinkit"

class Users extends BasePage<InjectedProps, State> {
	protected abortController: AbortController = new AbortController()
	protected editingProfiles: UserDomain.Profile[] = [
		UserDomain.Profile.SuperAdmin,
		UserDomain.Profile.RegionAdmin,
		UserDomain.Profile.LocalAuthorityAdmin
	]
	protected viewingProfiles: UserDomain.Profile[] = [
		UserDomain.Profile.LocalAuthorityConsultant
	]
	protected toolbar: ToolbarItem[] = this.getToolbarItems()
	
	constructor(props: InjectedProps) {
		super(props)

		this.state = {
			addUser: false,
			loadingUsers: [],
			loadingResources: false,
			titles: [],
			users: [],
			resourcesLoaded: false,
			sortedColumn: { name: "lastName" },
			viewUser: null,
			regions:[],
			searchUser: "",
			usersFiltered: [],
			isLoading:false
		}
	}
	protected timeout= null

	/** Minuscules et sans accents, pour une recherche insensible à la casse et aux accents. */
	private normalizeSearch = (value: string): string =>
		(value || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")

	private filterUser = () => {

		if(this.state.searchUser.length){
			const search = this.normalizeSearch(this.state.searchUser)
			// Recherche sur le prénom, le nom, l'email et la collectivité affichée
			const userSend = this.state.users.filter(userSearch => [
				userSearch.firstName,
				userSearch.lastName,
				userSearch.email,
				userSearch.relatedLocalAuthority
			].some(value => this.normalizeSearch(value).includes(search)))
			this.setState({usersFiltered:userSend})
		}
		else{
			this.setState({usersFiltered: this.state.users, isLoading: false})
		}		

	};

	private setSearch = () => {
		const {searchUser} = this.state
		clearTimeout(this.timeout)
		if(searchUser && searchUser.length){
			this.setState({isLoading:true})
			this.timeout =  setTimeout(() => {
				this.setState({isLoading:false})
				this.filterUser()
			}, 2000);
		}
		else{
			this.setState({usersFiltered: this.state.users, isLoading: false})
		}	
	}

	componentDidMount() {
		this.props.actions.setPageTitle("Utilisateurs")
		this.initState()
	}

	componentDidUpdate() {
		this.initState()
	}

	componentWillUnmount(): void {
		this.abortController.abort()
	}

	protected renderPageContent() {
		const currentUser = this.props.currentUser
		const currentUserProfile = currentUser ? UserDomain.getProfile(currentUser) : null

		return <div>
			<div className="searhBarWraper">
				{this.state.isLoading && (<Spinner fadeIn="none" name="wave" color="#3d3c3f" />)}
				<input
					type="text"
					placeholder="Rechercher un utilisateur..."
					onChange={(e) => this.setState({searchUser: e.target.value})}
					onKeyUp={() => this.setSearch()}
					onKeyDown={() => this.setSearch()}
				/>
			</div>
			<table className="table is-narrow is-fullwidth">
				<thead>
					<tr>
						<th></th>
						<th className="button-header" onClick={() => this.sortColumn("firstName")}>
							Prénom {this.getSortingIcon("firstName")}
						</th>
						<th className="button-header" onClick={() => this.sortColumn("lastName")}>
							Nom {this.getSortingIcon("lastName")}
						</th>
						<th>Adresse e-mail</th>
						<th className="button-header" onClick={() => this.sortColumn("collectives")}>
							Collectivités {this.getSortingIcon("collectives")}
						</th>
						<th className="button-header" onClick={() => this.sortColumn("profile")}>
							Profil {this.getSortingIcon("profile")}
						</th>
						{(UserDomain.Profile.LocalAuthorityConsultant !== currentUserProfile
						&& UserDomain.Profile.ServiceAgent !== currentUserProfile) &&
						[<th className="button-column" key={0}></th>,
						<th className="button-column" key={1}></th>,
						<th className="button-column" key={2}></th>,
						<th className="button-column" key={3}></th>,
						<th className="button-column" key={4}></th>]}
					</tr>
				</thead>
				<tbody>
				{ this.state.usersFiltered.length 
					? this.state.usersFiltered.map((user, i) => {
						const loading = this.rowIsLoading(user)
						const fullName = UserDomain.getFullName(user)
						return <tr key={i}>
							<td>
								{user.enabled
								? <span className="icon" title="Actif">
									<FontAwesomeIcon color="#32CD32" icon="user-circle" />
								</span>
								: <span className="icon" title="Bloqué">
									<FontAwesomeIcon color="#FF0000" icon="user-circle" />
								</span>}
							</td>
							<td>{user.firstName}</td>
							<td>{user.lastName}</td>
							<td>{user.email}</td>
							<td>{user.relatedLocalAuthority || ''}</td>
							<td>{UserDomain.getProfileLabel(UserDomain.getProfile(user))}</td>
							{(UserDomain.Profile.LocalAuthorityConsultant !== currentUserProfile
							&& UserDomain.Profile.ServiceAgent !== currentUserProfile) &&
							[<td key={0}>
								<button
								className={`button is-small ${loading ? "is-loading" : ""}`}
								title={`Voir le détail de ${fullName}`}
								onClick={() => this.handleClickViewUser(user)}>
									<span className="icon is-small">
										<FontAwesomeIcon icon="eye" />
									</span>
								</button>
							</td>,
							<td key={1}>
								<button
								className={`button is-small ${loading ? "is-loading" : ""}`}
								title={`Réinitialiser le mot de passe de ${fullName}`}
								onClick={() => this.handleResetPassword(user)}>
									<span className="icon is-small">
										<FontAwesomeIcon icon="key" />
									</span>
								</button>
							</td>,
							<td key={2}>
								{user.enabled
								? <button
									className={`button is-outlined is-small is-warning ${loading ? "is-loading" : ""}`}
									title={`Bloquer ${fullName}`}
									onClick={() => this.handleLockUser(user)}>
										<span className="icon is-small">
											<FontAwesomeIcon icon="lock" />
										</span>
									</button>
								: <button
									className={`button is-outlined is-small is-warning ${loading ? "is-loading" : ""}`}
									title={`Débloquer ${fullName}`}
									onClick={() => this.handleUnlockUser(user)}>
										<span className="icon is-small">
											<FontAwesomeIcon icon="unlock" />
										</span>
									</button>}
							</td>,
							<td key={3}>
								<button
								className={`button is-danger is-outlined is-small ${loading ? "is-loading" : ""}`}
								title={`Supprimer ${fullName}`}
								onClick={() => this.handleDeleteUser(user)}>
									<span className="icon is-small">
										<FontAwesomeIcon icon="trash" />
									</span>
								</button>
							</td>]}
						</tr>})
					: <tr><td colSpan={5}>Aucun utilisateur enregistré</td></tr>}
				</tbody>
			</table>

			{this.state.addUser &&
			<UserDetailModal
			currentUser={currentUser}
			regions={this.state.regions}
			localAuthorities={this.props.localAuthorities}
			titles={this.state.titles}
			users={this.state.users}
			onClose={() => this.handleCloseAddUserModal()}
			onError={error => this.handleError(error)}
			onUserCreated={user => this.handleUserCreated(user)} />}

			{this.state.viewUser &&
			<UserDetailModal
			currentUser={currentUser}
			localAuthorities={this.props.localAuthorities}
			titles={this.state.titles}
			user={this.state.viewUser}
			regions={this.state.regions}
			onClose={() => this.handleCloseViewUserModal()}
			onError={error => this.handleError(error)}
			onUserUpdated={user => this.handleUserUpdated(user)} />}
		</div>
	}

	protected isLoading(): boolean {
		return super.isLoading()
		|| this.state.loadingResources
		|| this.props.loadingLocalAuthorities
		|| this.props.loadingCurrentUser
	}

	private addLoadingUser(user: User): void {
		this.setState(state => {
			const loadingUsers = state.loadingUsers
			loadingUsers.push(user)
			return { loadingUsers }
		})
	}

	private getSortingIcon(columnName: ColumnName): React.ReactNode {
		if (this.state.sortedColumn.name !== columnName) return

		const icon: IconProp = this.state.sortedColumn.desc
		? "sort-alpha-down" : "sort-alpha-up"

		return <FontAwesomeIcon icon={icon}/>
	}

	private getToolbarItems(): ToolbarItem[] {
		const items: ToolbarItem[] = []
		items.push({
			allowedProfiles: [
				UserDomain.Profile.SuperAdmin,
				UserDomain.Profile.RegionAdmin,
				UserDomain.Profile.LocalAuthorityAdmin
			],
			icon: "user-plus",
			text: "Ajouter un utilisateur",
			title: "Ajouter un utilisateur",
			onClick: () => this.handleClickAddUser()
		})
		return items
	}

	private handleClickAddUser(): void {
		this.setState({ addUser: true })
	}

	private handleClickViewUser(user: User): void {
		this.setState({ viewUser: user })
	}

	private handleCloseAddUserModal(): void {
		this.setState({ addUser: false })
	}

	private handleCloseViewUserModal(): void {
		this.setState({ viewUser: null })
	}

	private handleDeleteUser(user: User): void {
		let message = `Vous êtes sur le point de supprimer l'utilisateur ${UserDomain.getFullName(user)}.\n`
		message += `Veuillez saisir "${DELETE}" pour confirmer.`

		if (prompt(message) !== DELETE) return

		this.addLoadingUser(user)

		UsersService.deleteUser(user)
		.then(() => {
			this.setState(state => {
				this.removeLoadingUser(user)

				const users = state.users
				const userIndex = UserDomain.getUserIndex(users, user)
				users.splice(userIndex, 1)

				return { users }
			})
		})
		.catch(reason => {
			this.props.actions.throwError(reason)
			this.removeLoadingUser(user)
		})
	}

	private handleError(reason: any): void {
		this.props.actions.throwError(reason)
	}

	private handleLockUser(user: User): void {
		this.addLoadingUser(user)

		UsersService.disableUser(user)
		.then(updatedUser => {
			this.removeLoadingUser(updatedUser)
			this.updateStateUser(updatedUser)
		})
		.catch(reason => {
			this.props.actions.throwError(reason)
			this.removeLoadingUser(user)
		})
	}

	private handleResetPassword(user: User): void {
		this.addLoadingUser(user)

		UsersService.resetPassword(user)
		.then(() => {
			this.removeLoadingUser(user)
		})
		.catch(reason => {
			this.props.actions.throwError(reason)
			this.removeLoadingUser(user)
		})
	}

	private handleUnlockUser(user: User): void {
		this.addLoadingUser(user)

		UsersService.enableUser(user)
		.then(updatedUser => {
			this.removeLoadingUser(updatedUser)
			this.updateStateUser(updatedUser)
		})
		.catch(reason => {
			this.props.actions.throwError(reason)
			this.removeLoadingUser(user)
		})
	}

	private handleUserCreated(user: User): void {
		this.setState(state => {
			const users = state.users
			users.push(user)
			return { addUser: false, users }
		}, this.filterUser)
	}

	private handleUserUpdated(user: User): void {
		this.updateStateUser(user)
	}

	private initState(): void {
		if (this.state.loadingResources) return
		if (this.state.resourcesLoaded) return

		this.setState({ loadingResources: true })

		Promise.all([
			UsersService.findUsers(this.abortController.signal),
			findTitles(this.abortController.signal),
			RegionsService.findRegions()
		])
		.then(([users, titles, regions]) => {
			this.setState({
				loadingResources: false,
				titles,
				regions,
				users: this.sortUsersByColumn(users, this.state.sortedColumn),
				usersFiltered:this.sortUsersByColumn(users, this.state.sortedColumn),
				resourcesLoaded: true })
		})
		.catch(error => {
			this.setState({ loadingResources: false, resourcesLoaded: false })
		})
	}

	private rowIsLoading(user: User) {
		return !!this.state.loadingUsers.find(u => u.id === user.id) || false
	}

	private removeLoadingUser(user: User): void {
		this.setState(state => {
			const loadingUsers = state.loadingUsers
			const loadingUserIndex = UserDomain.getUserIndex(loadingUsers, user)
			loadingUsers.splice(loadingUserIndex, 1)
			return { loadingUsers }
		})
	}

	private sortColumn(columnName: ColumnName): void {
		this.setState(prevState => {
			const desc: boolean = prevState.sortedColumn.name === columnName
			? !prevState.sortedColumn.desc : false
			const sortedColumn = { desc, name: columnName }

			return {
				sortedColumn,
				users: this.sortUsersByColumn(prevState.users, sortedColumn)
			}
		}, this.filterUser)
	}

	private sortUsersByColumn(users: User[], column: ColumnSorting): User[] {
		switch (column.name) {
			case "firstName": return UserDomain.sortByFirstName(users, column.desc)
			case "lastName": return UserDomain.sortByLastName(users, column.desc)
			case "profile": return UserDomain.sortByProfile(users, column.desc)
			case "collectives": return UserDomain.sortByCollective(users, column.desc)
		}
	}

	private updateStateUser(user: User): void {
		this.setState(state => {
			const users = state.users
			const userIndex = UserDomain.getUserIndex(users, user)
			if (null !== userIndex) users[userIndex] = user
			return { viewUser: null, users }
		}, this.filterUser)
	}
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(Users)

export interface Props extends BasePageProps {}

interface ColumnSorting {
	name: ColumnName;
	desc?: boolean;
}

interface Params {}

interface State {
	addUser: boolean;
	loadingUsers: User[];
	loadingResources: boolean;
	titles: Title[];
	users: User[];
	resourcesLoaded: boolean;
	sortedColumn: ColumnSorting;
	viewUser: User;
	regions:any;
	searchUser: string;
	usersFiltered: User[];
	isLoading: boolean;
}

type ColumnName = "firstName" | "lastName" | "profile" | "collectives"
type InjectedProps = MappedActionsProps &
Props &
ReducerState &
RouteComponentProps<Params>



// WEBPACK FOOTER //
// ./src/component/users/index.tsx